// extracted by mini-css-extract-plugin
module.exports = {"button":"_5aff165","right":"_62d43b9"};